<script>
// import axios from "axios";

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapGetters, mapActions, mapState } from "vuex";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Item Categories",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: "Pharmacy Item Categories",
      items: [
        {
          text: "Home",
          href: "#/",
        },
        {
          text: "Item Categories",
          active: true,
        },
      ],
      totalRows: 1,

      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      modal_id: "",
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "categoryName",
          sortable: true,
          label: "NAME",
        },
        {
          key: "description",
          sortable: true,
          label: "DESCRIPTION",
        },
        {
          sortable: false,
          key: "actions",
          label: "ACTIONS",
        },
      ],
      existingCat: [],
      nameError: "",
      symbolError: "",

      // Value from user input for adding category
      data: {
        name: "",
        desc: "",
      },
      // edit cat
      editdata: {
        new_name: "",
        desc: "",
        id: "",
      },
      // delete cat
      deletedata: {
        name: "",
        desc: "",
        id: "",
      },
    };
  },
  computed: {
    // MAP STATE
    ...mapState("notification", [
      "notificationtype",
      "notification_message",
      "notification_show",
    ]),
    ...mapGetters("pharmacy", ["ItemCategories", "CategoryState"]),
    ...mapGetters("auth", ["user_permissions"]),

    /**
     * Total no. of records
     */

    rows() {
      return this.ItemCategories ? this.ItemCategories.length : 1;
    },

    /**
     * Todo list of records
     */
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.ItemCategories ? this.ItemCategories.length : 1;
  },
  watch: {
    notification_show(newValue) {
      // Do whatever makes sense now
      if (newValue == true) {
        this.closeModal(this.modal_id);
        if (this.notificationtype == "success") {
          this.$toast.success(this.notification_message.msg);
        } else {
          this.$toast.error(this.notification_message.msg);
        }
      }
    },
  },
  methods: {
    ...mapActions({
      FetchCategories: "pharmacy/fetchItemCategories",
      AddCat: "pharmacy/addCategory",
      EditCat: "pharmacy/editCategory",
      DeleteCat: "pharmacy/deleteCategory",
    }),
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    checkName() {
      //when creating a new one
      if (this.data.name != "") {
        this.existingCat = this.ItemCategories.filter((cat) => {
          return cat.categoryName.toUpperCase() == this.data.name.toUpperCase();
        });
        if (this.existingCat.length) {
          this.nameError = this.data.name + " exists already";
        } else {
          this.nameError = "";
        }
      } else {
        this.existingCat = [];
      }
    },

    addCat(modalId) {
      this.modal_id = modalId;

      if (this.data.name === "") {
        this.nameError = "Category name field is required";
        return;
      } else {
        this.nameError = "";
      }
      if (this.existingCat.length) {
        this.nameError = this.data.name + " exists already please";
        return;
      } else {
        this.nameError = "";
      }

      this.AddCat(this.data);
    },

    resetAddCat() {
      this.data.name = "";
      this.data.desc = "";
      this.nameError = "";
      this.modal_id = "";
    },
    resetEditCat() {
      this.editdata.new_name = "";
      this.editdata.desc = "";
      this.editdata.id = "";
      this.nameError = "";
      this.modal_id = "";
    },

    resetDeleteCat() {
      this.deletedata.name = "";
      this.deletedata.id = "";
      this.modal_id = "";
    },

    resetError() {
      this.nameError = "";
    },
    showEditModal(data) {
      this.editdata.new_name = data.item.categoryName;
      this.editdata.desc = data.item.description;
      this.editdata.id = data.item.id;
    },
    editCat(modalId) {
      this.modal_id = modalId;
      if (this.editdata.new_name === "") {
        this.nameError = "Category name field is required";
        return;
      } else {
        this.nameError = "";
      }
      this.EditCat(this.editdata);
    },
    showDeleteModal(data) {
      this.deletedata.name = data.item.categoryName;
      this.deletedata.symbol = data.item.symbol;
      this.deletedata.id = data.item.id;
    },
    deleteCat(modalId) {
      this.modal_id = modalId;
      this.DeleteCat(this.deletedata);
    },

    //== close modal
    closeModal(modalId) {
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
      });
    },
  },
  created() {
    this.FetchCategories();
  },
};
</script>

<template>
  <Layout>
    <Toasts
      :show-progress="true"
      :rtl="true"
      :max-messages="20"
      :time-out="3000"
      :closeable="false"
      :solid="true"
    ></Toasts>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-12">
                <div>
                  <b-button
                    v-if="user_permissions.add_pharmacy_categories"
                    class="float-end"
                    variant="primary"
                    v-b-modal.add-category-modal
                    ><i class="fa fa-plus"></i> New Category</b-button
                  >

                  <!-- modal starts -->
                  <b-modal id="add-category-modal" hide-footer @hidden="resetAddCat">
                    <template #modal-title> Add New Category </template>
                    <div class="form-group mb-3">
                      <label>Category Name</label>
                      <div class="input-group">
                        <input
                          type="text"
                          placeholder="Enter Category Name"
                          class="form-control"
                          @keyup="checkName"
                          @input="resetError"
                          v-model="data.name"
                        />
                      </div>
                      <div class="text-danger" v-if="nameError">
                        <em>{{ nameError }}</em>
                      </div>
                    </div>
                    <div class="form-group mb-3">
                      <label>Description</label>
                      <div class="input-group">
                        <input
                          type="text"
                          placeholder="Enter Description"
                          class="form-control"
                          @input="resetError"
                          v-model="data.desc"
                        />
                      </div>
                    </div>
                    <div class="modal-footer">
                      <button
                        type="button"
                        class="btn btn-danger"
                        data-dismiss="modal"
                        @click="closeModal('add-category-modal')"
                      >
                        <i class="fa fa-times"></i> Close
                      </button>
                      <button
                        type="button"
                        class="btn btn-primary"
                        @click="addCat('add-category-modal')"
                      >
                        <i class="fa fa-check"></i>
                        Submit
                        <b-spinner
                          v-if="CategoryState"
                          variant="light"
                          small
                          label="Spinning"
                        ></b-spinner>
                      </button>
                    </div>
                  </b-modal>
                  <!-- modal ends -->
                </div>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                class="datatables"
                :items="ItemCategories ? ItemCategories : []"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>

                <template #cell(actions)="data">
                  <b-button
                    v-if="user_permissions.edit_pharmacy_categories"
                    size="sm"
                    variant="primary"
                    v-b-modal.edit-category-modal
                    class="m-2"
                    @click="showEditModal(data)"
                    ><i class="fa fa-edit"></i> Edit</b-button
                  >
                  <b-button
                    v-else
                    disabled
                    size="sm"
                    variant="primary"
                    v-b-modal.edit-category-modal
                    class="m-2"
                    @click="showEditModal(data)"
                    ><i class="fa fa-edit"></i> Edit</b-button
                  >
                  <b-button
                    v-if="user_permissions.delete_pharmacy_categories"
                    size="sm"
                    variant="danger"
                    v-b-modal.delete-category-modal
                    @click="showDeleteModal(data)"
                    ><i class="fa fa-trash"></i> Delete</b-button
                  >
                  <b-button
                    v-else
                    disabled
                    size="sm"
                    variant="danger"
                    v-b-modal.delete-category-modal
                    @click="showDeleteModal(data)"
                    ><i class="fa fa-trash"></i> Delete</b-button
                  >
                </template>
              </b-table>
              <center>
                <h3 v-if="!ItemCategories" class="text-primary">
                  <b-spinner class="m-0" variant="primary" role="status"></b-spinner>
                  Please wait...
                </h3>
              </center>
            </div>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
            <!-- edit modal starts -->
            <b-modal id="edit-category-modal" hide-footer @hidden="resetEditCat">
              <template #modal-title> Edit Category {{ editdata.new_name }}</template>
              <div class="form-group mb-3">
                <label>Category Name</label>
                <div class="input-group">
                  <input
                    type="text"
                    class="form-control"
                    @input="resetError"
                    v-model="editdata.new_name"
                  />
                </div>
                <div class="text-danger" v-if="nameError">
                  <em>{{ nameError }}</em>
                </div>
              </div>
              <div class="form-group mb-3">
                <label>Description</label>
                <div class="input-group">
                  <input
                    type="text"
                    class="form-control"
                    @input="resetError"
                    v-model="editdata.desc"
                  />
                </div>
              </div>
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-danger"
                  data-dismiss="modal"
                  @click="closeModal('edit-category-modal')"
                >
                  <i class="fa fa-times"></i> Close
                </button>
                <button
                  type="button"
                  class="btn btn-primary"
                  @click="editCat('edit-category-modal')"
                >
                  <i class="fa fa-check"></i>
                  Save Changes
                  <b-spinner
                    v-if="CategoryState"
                    variant="light"
                    small
                    label="Saving"
                  ></b-spinner>
                </button>
              </div>
            </b-modal>
            <!-- modal ends -->

            <!-- modal delete category starts -->
            <b-modal id="delete-category-modal" hide-footer @hidden="resetDeleteCat">
              <template #modal-title>
                <h4 class="text-danger">
                  Delete Category {{ deletedata.name }}
                </h4></template
              >
              <div class="form-group mb-3">
                <div class="input-group">
                  <h5>
                    Do you want to delete this Category? Click Proceed Button to delete.
                  </h5>
                </div>
              </div>
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-secondary"
                  data-dismiss="modal"
                  @click="closeModal('delete-category-modal')"
                >
                  <i class="fa fa-times"></i> Close
                </button>
                <button
                  type="button"
                  class="btn btn-danger"
                  @click="deleteCat('delete-category-modal')"
                >
                  <i class="fa fa-trash"></i> Proceed
                  <b-spinner
                    v-if="CategoryState"
                    variant="light"
                    small
                    label="Deleting"
                  ></b-spinner>
                </button>
              </div>
            </b-modal>
            <!-- modal ends -->
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
